"use client";

import { UseFormReturn } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Form } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { AuthCard } from "@/components/(auth)/auth-card";
import { TermsFooter } from "@/components/(auth)/login/terms-footer";
import { ArrowLeft } from "lucide-react";
import type { PasswordFormData, LoadingAction } from "./login-form.types";

interface PasswordStepProps {
  form: UseFormReturn<PasswordFormData>;
  email: string;
  isLoading: boolean;
  loadingAction: LoadingAction;
  error: string;
  onSubmit: (data: PasswordFormData) => void;
  onBack: () => void;
}

export function PasswordStep({
  form,
  email,
  isLoading,
  loadingAction,
  error,
  onSubmit,
  onBack,
}: PasswordStepProps) {
  return (
    <>
      <AuthCard title="Enter your password" subtitle={email}>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
            <FormField
              control={form.control}
              name="password"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Password</FormLabel>
                  <FormControl>
                    <Input
                      type="password"
                      autoComplete="current-password"
                      autoFocus
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            {error && (
              <div className="text-center text-sm text-red-500">{error}</div>
            )}

            <Button type="submit" className="w-full" disabled={isLoading}>
              {loadingAction === "password" ? "Signing in..." : "Sign in"}
            </Button>
          </form>
        </Form>

        <Button variant="ghost" className="w-full" onClick={onBack}>
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
      </AuthCard>
      <TermsFooter />
    </>
  );
}
